
import {
  defineComponent,
  ref,
} from 'vue';

export default defineComponent({
  emits: ['input'],

  props: {
    value: [String, Number],
  },

  setup(props, context) {
    const root = ref();

    const emitInput = () => {
      if (root.value) {
        context.emit('input', root.value.value);
      }
    };

    return {
      emitInput,
      root,
    };
  },
});
